import PiCreatorStringDropdown from "../../../components/PiCreatorDropdown/PiCreatorStringDropdown";

export default function NodeStringDropdown(props: {
  selectedItem: string;
  items: string[] | undefined;
  label?: string;
  onClick: (item: string) => void;
}) {
  return (
    <PiCreatorStringDropdown
      label={props.label}
      selectedItem={props.selectedItem}
      items={props.items}
      onClick={props.onClick}
      dropdownStyle="square"
      textClassName="text-[13px] text-creator-text"
    />
  );
}
